import React, { useCallback, useEffect, useState } from "react";
import { getAtualDate } from "./utils";
import { DashboardContainer } from "./style";
import { useGlobal } from "../../../hooks/global";
import { useApi } from "../../../hooks/api";
import { correct_date_filter, setUpConsultation } from "../../../services/generalServices";
import { DashboardPage } from "../../../components/DashboardPage";
import { DashboardHeader } from "../../Dashboard/DashboardHeader";
import { ReservationsCard } from "../../Dashboard/ReservationsCard";
import { ReservationsTableListRoot } from "./ReservationsTableList";
import { accommodation_status } from "../../../utils/reservation_status";

const initalRange = {
  from: { day: 1, month: 1, year: 2024 },
  to: getAtualDate({ daysBefore: 0 }),
};

interface StatusHistory {
  date: string;
  [status: string]: number | string;
}

export const DashboardRoot: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());
  const [range, setRange] = useState<{ from: any; to: any }>(initalRange);
  const [dateType, setDateType] = useState<string>("CREATED_DATE");
  const [controlRender, setControlRender] = useState(false);
  const [statisticsPerStatus, setStatisticsPerStatus] = useState({});
  const [statisticsPerOrigin, setStatisticsPerOrigin] = useState({});
  const [reservationInfos, setReservationInfos] = useState({});
  const [totalAccomoddation, setTotalAccomoddation] = useState(null);
  const [chartTemporalData, setChartTemporalData] = useState<any>(null);

  const [businessIdSelected, setBusinessIdSelected] = useState<string | null>(null)

  const { theme, getCorrectMaxWidth, notify, loadingResize } = useGlobal();
  const { api } = useApi()

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };


  const search = useCallback(async () => {
    setLoading(true)
    try {
      const date_init = range.from ? range.from : (range.to ? range.to : null)
      const date_end = range.to ? range.to : (range.from ? range.from : null)
      const start_date = date_init ? correct_date_filter(date_init) : null
      const end_date = date_end ? correct_date_filter(date_end) : null

      const query = setUpConsultation({
        end_date,
        start_date,
        dateType
      });

      const [{ data: reservationsInfosData }, { data: byStatusData }, { data: byOriginData }, { data: dataTotal }, { data: temporalAccommodations }] = await Promise.all([
        api.get('/root/reservations-check-in-infos' + '?' + query),
        api.get('/root/aggrouped-reservations' + '?' + query + '&aggruped_by=status'),
        api.get('/root/aggrouped-reservations' + '?' + query + '&aggruped_by=origin'),
        api.get('/root/total-accommodations'),
        await api.get('/root/accommodations-status-temporal' + '?' + query)
      ])
      setReservationInfos(reservationsInfosData)
      setStatisticsPerStatus(byStatusData)
      setStatisticsPerOrigin(byOriginData)
      setTotalAccomoddation(dataTotal?.total ?? 0)

      //start chart temporal
      const data: Record<string, StatusHistory> = temporalAccommodations;
      const dates = Object.keys(data);

      const statusTypes = Array.from(
        new Set(
          dates.flatMap((date) =>
            Object.keys(data[date]).filter((key) => key !== 'date')
          )
        )
      );

      const datasets = statusTypes.map((status) => ({
        name: accommodation_status[status]?.text || status,
        data: dates.map((date) => data[date][status] || 0),
        fill: false,
        borderColor: getRandomColor(),
      }));

      setChartTemporalData({
        name: dates,
        datasets,
      });
      //end chart temporal

      setLastUpdate(new Date())
    } catch (err) {
      notify('Erro ao buscar dados do dashboard', 'error')
    }

    setLoading(false)
  }, [range])

  useEffect(() => { search() }, [controlRender, range, businessIdSelected])

  useEffect(() => { setControlRender((prev) => !prev) }, [loadingResize])

  const children = (
    <DashboardContainer>
      <DashboardHeader
        lastUpdate={lastUpdate}
        loading={loading}
        onSearch={() => setControlRender((prev) => !prev)}
        range={range}
        setRange={setRange}
        setDateType={setDateType}
        setBusinessIdSelected={setBusinessIdSelected}
      />
      <ReservationsCard
        loading={loading}
        statisticsPerStatus={statisticsPerStatus}
        statisticsPerOrigin={statisticsPerOrigin}
        reservationInfos={reservationInfos as any}
        totalAccomoddation={totalAccomoddation}
        chartTemporalData={chartTemporalData}
      />
      <ReservationsTableListRoot
        businessIdSelected={businessIdSelected}
        theme={theme}
        range={range}
        maxWidth={getCorrectMaxWidth()}
        minWidth={250}
      />
    </DashboardContainer>
  )

  return (
    <DashboardPage>
      {controlRender && children}
      {!controlRender && children}
    </DashboardPage>
  )
};
